
import {HTTPServer} from '@/common/js/ajax.js'
import tool from '@/common/js/tool.js'

export default {
  name: 'customerDetail',
  props: ['customer'],
  data () {
    return {
      response: this.customer,
      activeNames: ['1', '2', '3', '4'],
      tabType: 0,
      dialogAdd: false,
      customerDetail: {},
      dialogTransfer: false,
      transferOfficer: null,
      dialogDelete: false,
      dialogStatus: false,
      dialogfeature: false,
      userList: [],
      featureList: [],
      featureData: {data: [], type: 1},
      logList: [],
      tableList: [],
      dialogAddDetail: false,
      dialogAdditionalAdd: false,
      additionalDtl: {},
      dialogReductionAdd: false,
      dialogReductionDetail: false,
      reductionDtl: {},
      dialogRenewalAdd: false,
      renewalDtl: {},
      dialogRenewalDetail: false,
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      saveAddData: {},
      businessRemark: {
        0: '升级版本',
        1: '续费',
        2: '扩充数据',
        3: '扩充空间',
        4: '增加账户数'
      },
      searchInput: '',
      dataTime: ''
    }
  },
  watch: {
    // 监听路由变化
    customer (data) {
      console.log('watch', this.customerDetail)
      this.customerDetail = JSON.parse(JSON.stringify(this.customer))
    },
    saveAddData () {
      if (this.saveAddData.type === 5) {
        this.editFormalUser(this.saveAddData.jsondata)
      }
    }
  },
  mounted () {
    console.log('mounted', this.customerDetail)
    this.queryUserList()
    this.queryAllChargingStrategy()
    this.queryFchBtnAuth(({moduleId: 2}))
    this.customerDetail = JSON.parse(JSON.stringify(this.customer))
    /** 添加、编辑客户 */
    this.$bus.on('saveAddModal', (jsondata, type) => {
      this.saveAddData = {
        jsondata: jsondata,
        type: type
      }
    })
    // 关闭添加窗口
    this.$bus.on('closeAddModal', (value) => {
      if (value) {
        this.dialogAdd = false
        this.dialogAdditionalAdd = false
        this.dialogReductionAdd = false
        this.dialogRenewalAdd = false
      }
    })
    // 功能清单-实时
    this.$bus.on('feature-edit', (value) => {
      if (value) {
        this.feature = value
      }
    })
    // 关闭添加窗口
    this.$bus.on('closeAddDetailModal', (value) => {
      if (value) {
        this.dialogAddDetail = false
        this.dialogRenewalDetail = false
        this.dialogReductionDetail = false
      }
    })
    /** 增购 - 更新列表 */
    this.$bus.off('query-additional-list')
    this.$bus.on('query-additional-list', (value, page) => {
      if (value) {
        if (page) {
          this.pageNum = 1
        }
        this.dtlChange(this.tabType)
        this.$bus.emit('query-formal-list', true)
      }
    })
    /** 减购 - 更新列表 */
    this.$bus.off('query-reduction-list')
    this.$bus.on('query-reduction-list', (value, page) => {
      if (value) {
        if (page) {
          this.pageNum = 1
        }
        this.dtlChange(this.tabType)
        this.$bus.emit('query-formal-list', true)
      }
    })
    /** 续费 - 更新列表 */
    this.$bus.off('query-renewal-list')
    this.$bus.on('query-renewal-list', (value, page) => {
      if (value) {
        if (page) {
          this.pageNum = 1
        }
        this.dtlChange(this.tabType)
        this.$bus.emit('query-formal-list', true)
      }
    })
  },
  methods: {
    /** 详情导航切换 */
    dtlChange (type, tag) {
      if (tag !== 'page') {
        this.pageNum = 1
        this.pageSize = 20
      }
      this.tabType = type
      this.tableList = []
      var jsondata = {'pageNum': this.pageNum, 'pageSize': this.pageSize, 'user_id': this.customerDetail.id}
      if (type === 1) {
        this.getCustomerCommodityList({userId: this.customerDetail.id})
      } else if (type === 2) {
        HTTPServer.queryAdditionalListByFormalUser(jsondata, 'Loading').then((res) => {
          this.tableList = res.dataList
          var pageInfo = res.pageInfo
          this.tableTotal = pageInfo.totalRows
        })
        this.queryFchBtnAuth2(({moduleId: 3}))
      } else if (type === 3) {
        HTTPServer.queryReductionListByFormalUser(jsondata, 'Loading').then((res) => {
          this.tableList = res.dataList
          var pageInfo = res.pageInfo
          this.tableTotal = pageInfo.totalRows
        })
        this.queryFchBtnAuth2(({moduleId: 4}))
      } else if (type === 4) {
        HTTPServer.queryRenewalListByFormalUser(jsondata, 'Loading').then((res) => {
          this.tableList = res.dataList
          var pageInfo = res.pageInfo
          this.tableTotal = pageInfo.totalRows
        })
        this.queryFchBtnAuth2(({moduleId: 5}))
      } else if (type === 5) {
        jsondata.user_id = this.customerDetail.company_id
        HTTPServer.getLocalMonitorList(jsondata, 'Loading').then((res) => {
          this.tableList = res.dataList
          var pageInfo = res.pageInfo
          this.tableTotal = pageInfo.totalRows
        })
      } else if (type === 6) {
        jsondata.moduleType = 2
        jsondata.moduleId = this.customerDetail.id
        this.queryRecordList(jsondata)
      } else if (type === 7) {
        jsondata.keyWord = ''
        jsondata.businessType = ''
        HTTPServer.getAllRenewList(jsondata, 'Loading').then((res) => {
          this.tableList = res.dataList
          var pageInfo = res.pageInfo
          this.tableTotal = pageInfo.totalRows
        })
      } else if (type === 8) {
        this.queryDataembeddingpointList()
      }
    },
    /** 点击菜单项触发的事件回调 */
    handleCommand (command) {
      if (command === '1') {
        this.dialogTransfer = true
        this.transferOfficer = null
      } else if (command === '2') {
        this.dialogStatus = true
      } else if (command === '3') {
        this.dialogDelete = true
      }
    },
    /** 获取列表 */
    queryUserList () {
      var jsondata = {'pageNum': 1, 'pageSize': 9999}
      HTTPServer.queryUserList(jsondata, 'Loading').then((res) => {
        this.userList = res.dataList
      })
    },
    // 编辑详情
    editCustomer () {
      this.dialogAdd = true
      this.customerDetail.addType = 5
    },
    /** 编辑正式客户 */
    editFormalUser (jsondata) {
      console.log('editFormalUser', jsondata)
      let obj = JSON.parse(JSON.stringify(jsondata))
      delete obj.cm_name
      HTTPServer.editFormalUser(obj, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '保存成功！',
          type: 'success'
        })
        this.dialogAdd = false
        if (this.customerDetail.edition !== jsondata.edition && this.$route.name === 'Strategy') {
          this.$bus.emit('query-strategy-list', true)
        }
        let obj = {
          'company_name': jsondata.company_name,
          'user_name': jsondata.user_name,
          'phone': jsondata.phone,
          'edition': jsondata.edition,
          'cm_id': jsondata.cm_id,
          'cm_name': jsondata.cm_name,
          'allow_number': jsondata.allow_number,
          'start_time': jsondata.start_time,
          'end_time': jsondata.end_time,
          'attachment_size': jsondata.attachment_size,
          'data_size': jsondata.data_size,
          'invite_code': jsondata.invite_code,
          'seat_unit_price': jsondata.seat_unit_price,
          'remark': jsondata.remark,
          'modify_by': (JSON.parse(sessionStorage.getItem('userInfo'))).user_name,
          'modify_time': (new Date()).getTime()
        }
        let contains = tool.contains(this.userList, 'id', jsondata, 'id')
        if (contains) {
          obj.customer_id = contains.id
          obj.customer_name = contains.user_name
        }
        this.customerDetail = Object.assign({}, this.customerDetail, obj)
        this.$bus.emit('query-formal-list', true)
      })
    },
    /** 转移负责人 */
    transfer () {
      var jsondata = {'id': this.customerDetail.id, 'user_id': this.transferOfficer}
      HTTPServer.updateFormalUserCustomer(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        let contains = tool.contains(this.userList, 'id', this.transferOfficer)
        if (contains) {
          this.customerDetail.customer_id = contains.id
          this.customerDetail.customer_name = contains.user_name
        }
        this.customerDetail.modify_by = (JSON.parse(sessionStorage.getItem('userInfo'))).user_name
        this.customerDetail.modify_time = (new Date()).getTime()
        this.dialogTransfer = false
        this.$bus.emit('query-formal-list', true)
      })
    },
    /** 禁用/启用用户 */
    userStatus () {
      var jsondata = {id: this.customerDetail.id, status: (this.customerDetail.status === '0') ? '1' : '0'}
      HTTPServer.FenableDisableUser(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.customerDetail.modify_by = (JSON.parse(sessionStorage.getItem('userInfo'))).user_name
        this.customerDetail.modify_time = (new Date()).getTime()
        this.dialogStatus = false
        this.customerDetail.status = jsondata.status
        this.$bus.emit('query-formal-list', true)
      })
    },
    /** 删除客户 */
    userDelete (id) {
      var jsondata = {'id': this.customerDetail.id}
      HTTPServer.delFormalUser(jsondata, 'Loading').then((res) => {
        this.dialogDelete = false
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.$bus.emit('closeDetailModal', true)
        this.$bus.emit('query-formal-list', true, true)
      })
    },
    // 关闭详情弹框
    closeDialog () {
      this.$bus.emit('closeDetailModal', true)
    },
    /** 功能清单 - 修改弹窗 */
    editfeature () {
      this.featureData.data.map((item) => {
        item.funcList.map((fun) => {
          if (fun.choice === '1' && (fun.from_type === '0' || fun.from_type === '2')) {
            fun.disabled = true
          }
        })
      })
      this.featureData.type = 2
      console.log(this.featureData)
      this.dialogfeature = true
    },
    /** 功能清单 - 保存 */
    savefeature () {
      console.log(this.feature)
      var jsondata = {'userId': this.customerDetail.id, 'moduleAuth': this.featureInit2(this.feature, '1')}
      console.log(jsondata)
      HTTPServer.saveCustomerCommodity(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '保存成功！',
          type: 'success'
        })
        this.dialogfeature = false
        this.featureData = Object.assign({}, this.featureData, {
          data: this.feature,
          type: 1
        })
      })
    },
    /** 增购 */
    additionalRow (row, event, column) {
      this.dialogAddDetail = true
      this.additionalDtl = row
    },
    /** 减购 */
    reductionRow (row, event, column) {
      this.dialogReductionDetail = true
      this.reductionDtl = row
    },
    /** 续费 */
    renewalRow (row, event, column) {
      this.dialogRenewalDetail = true
      this.renewalDtl = row
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.dtlChange(this.tabType, 'page')
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      this.dtlChange(this.tabType, 'page')
    },
    /** 增购 - 添加 */
    additionalDialog () {
      this.dialogAdditionalAdd = true
      this.additionalDtl = {'id': this.customerDetail.id, 'company_name': this.customerDetail.company_name, 'user_name': this.customerDetail.user_name, 'phone': this.customerDetail.phone}
    },
    /** 减购 - 添加  */
    reductionDialog () {
      this.dialogReductionAdd = true
      this.reductionDtl = {'id': this.customerDetail.id, 'company_name': this.customerDetail.company_name, 'user_name': this.customerDetail.user_name, 'phone': this.customerDetail.phone}
    },
    /** 续费 - 添加  */
    renewalDialog () {
      this.dialogRenewalAdd = true
      this.renewalDtl = {'account_id': this.customerDetail.id, 'company_name': this.customerDetail.company_name, 'user_name': this.customerDetail.user_name, 'phone': this.customerDetail.phone}
    },
    contentInit (row) {
      let txt = row.order_content
      if (row.order_content === '0' || !row.order_content) {
        txt = '-'
      } else {
        if (row.business_type === 1) {
          txt += '天'
        } else if (row.business_type === 2) {
          txt += '条'
        } else if (row.business_type === 3) {
          txt += 'G'
        } else if (row.business_type === 4) {
          txt += '个'
        }
      }
      return txt
    },
    /** 搜索 */
    search () {
      this.searchValue = JSON.parse(JSON.stringify(this.searchInput))
      this.pageNum = 1
      this.pageSize = 20
      this.queryDataembeddingpointList()
    },
    /** 运营管理 */
    queryDataembeddingpointList () {
      var jsondata = {
        'pageNum': this.pageNum,
        'pageSize': this.pageSize,
        'queryWhere': {
          'keyword': this.searchValue,
          'companyId': this.customerDetail.id,
          'operationTime': {}
        }
      }
      if (this.dataTime) {
        jsondata.queryWhere.operationTime.startTime = this.dataTime
        jsondata.queryWhere.operationTime.endTime = this.dataTime + 86399999
      }
      console.log(jsondata)
      HTTPServer.queryDataembeddingpointList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/controller/formal-detail.js